import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-637480ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-container mb-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Reference Result")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No tenant reference available. ")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-eye text-primary" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_SearchHeader = _resolveComponent("SearchHeader")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navigator, { text: "Back to dashboard" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SearchHeader, {
        ref: "searchHeader",
        loading: _ctx.loading,
        onSearch: _ctx.handleSubmitSearchTenant
      }, null, 8, ["loading", "onSearch"]),
      _createVNode(_component_Card, null, {
        title: _withCtx(() => [
          _hoisted_2
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Table, {
            headers: _ctx.table.headers,
            items: _ctx.tenants
          }, {
            "empty-message": _withCtx(() => [
              _hoisted_3
            ]),
            first_name: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_ctx.capitalizeStr(item.first_name)) + " " + _toDisplayString(_ctx.capitalizeStr(item.last_name)), 1)
            ]),
            date_of_birth: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_ctx.dateFormat(item.date_of_birth)), 1)
            ]),
            action: _withCtx(({ item }) => [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.viewProfile(item)),
                class: "btn"
              }, _hoisted_6, 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["headers", "items"])
        ]),
        _: 1
      })
    ])
  ]))
}